module.exports = __webpack_public_path__ + "img/information_banner.a5627809.jpg";